/// <amd-module name="DistributedTaskUI/Resources/ResourcesActionsHub" />
import { Action } from "VSS/Reflux/Action";
import { ResourcesHubData } from "DistributedTask/Client/Contracts/TaskAgent";

export class ResourcesActionsHub {

    constructor() {
        this.initialize();
    }
    public static getKey(): string {
        return "resources-hub-actions";
    }

    public initialize(instanceId?: string): void {
        this._initializeList = new Action<ResourcesHubData>();
        this._filterList = new Action<ResourcesHubData>();
        this._updateList = new Action<ResourcesHubData>();
    }

    public get initializeResources(): Action<ResourcesHubData> {
        return this._initializeList;
    }

    public get applyFilters(): Action<ResourcesHubData> {
        return this._filterList;
    }

    public get fetchNextPage(): Action<ResourcesHubData> {
        return this._updateList;
    }

    private _initializeList: Action<ResourcesHubData>;
    private _filterList: Action<ResourcesHubData>;
    private _updateList: Action<ResourcesHubData>;
}
